<template lang="pug">
v-toolbar.elevation-0(app, :clipped-left='clipped', color='primary', dark)
  v-toolbar-side-icon(@click.stop='drawer = !drawer')
  v-toolbar-title.ml-0
    v-layout(align-center)
      v-list-tile.hidden-phone(avatar)
        //- v-list-tile-avatar
          img(src='/images/user.png')
        v-list-tile-content
          v-container.pl-0
            v-list-tile-title(v-if='$store.state.user.me.userInfo') Welkom {{ $store.state.user.me.userInfo.initials }} {{ $store.state.user.me.userInfo.lastName }}
  v-spacer
  v-menu(offset-y, content-class='small', offset-x)
    v-btn(slot='activator', color='white', flat, small)
      v-icon.mr-2 fa fa-user
      span(style='font-size: 14px;') Mijn account
    v-list
      v-list-tile(:to='{ name: "settings" }')
        v-list-tile-action
          v-icon(color='primary') fas fa-cog
        v-list-tile-content
          v-list-tile-title Instellingen
      v-list-tile(:to='{ name: "settings invoices" }')
        v-list-tile-action
          v-icon(color='primary') fas fa-file-pdf
        v-list-tile-content
          v-list-tile-title Facturen
      v-list-tile(:to='{ name: "settings users" }')
        v-list-tile-action
          v-icon(color='primary') fas fa-users
        v-list-tile-content
          v-list-tile-title Gebruikers

      v-divider.mb-2.mt-2

      v-list-tile(@click='logout')
        v-list-tile-action
          v-icon fas fa-power-off
        v-list-tile-content
          v-list-tile-title Uitloggen
</template>

<script>
export default {
  props: {
    value: Boolean,
    clipped: Boolean
  },

  data () {
    return {
      drawer: this.value
    }
  },

  methods: {
    logout () {
      this.$store.commit('auth/logout')

      window.location.reload()
    }
  },

  watch: {
    drawer (v) {
      this.$emit('input', v)
    },

    value (v) {
      this.drawer = v
    }
  }
}
</script>

<style lang="scss" scoped>
@import "src/styles/variables";

.v-list {
  padding: 10px 0;

  .v-list__tile {
    .v-list__tile__action {
      justify-content: center;
      min-width: 46px;
    }
  }
}
</style>
